module.exports = __webpack_public_path__ + "static/media/Introduksjon-sprakforstaelse.7bb40c73.mp3";